import { Controller } from '@hotwired/stimulus';
import { subscribeTo } from '../channels/sales_team_channel';

// Keeps the sidebar's pending-emails badge in sync with the team's draft
// queue from any page in the app — drafts land, approvals/rejections
// land, the badge updates without a refresh.
export default class extends Controller {
  static targets = ['badge'];
  static values = { teamId: Number };

  connect() {
    if (!this.teamIdValue) return;
    // The channel subscribe is idempotent — sales-team page subscribes
    // first via its own controller, sidebar re-subscribes here. Same
    // team, same channel, no conflict.
    subscribeTo(this.teamIdValue);
  }
}
